<template>
 
  <v-app id="VFYPartners" >
  
      <v-app-bar
      app clipped permanent color="primary" dark>
    
      <!-- <img src="@/assets/ares.png" height="50px" width="50px" />    -->
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
         <span class="hidden-sm-and-down">VFY Sales partner</span>
      </v-toolbar-title>
      
      <v-toolbar-items>  

        <v-menu offset-y open-on-hover close-on-click>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on" small router to="/homepage">Home</v-btn>  
          </template> 
        </v-menu>

        <v-menu offset-y open-on-hover close-on-click>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on" small>MyAccount<v-icon dark right small>mdi-chevron-down</v-icon></v-btn>  
          </template>     
            <v-list dense>
              <v-list-item router to="/inpt/onInpt">
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item>
            </v-list>
        </v-menu>

        <v-menu offset-y open-on-hover close-on-click>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on" small router to="/api/apiNavBar">API</v-btn>  
          </template> 
        </v-menu>

        <!--  Met sub menu 
        <v-menu offset-y open-on-hover close-on-click>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on" small>API<v-icon dark right small>mdi-chevron-down</v-icon></v-btn>  
          </template>     
            <v-list dense>
              <v-list-item router to="/api/apiNavBar">
                <v-list-item-title>Calls</v-list-item-title>
              </v-list-item>
            </v-list>
        </v-menu>
        -->

       

      </v-toolbar-items>
      <v-spacer />
    </v-app-bar>
  </v-app>
</template>

<script>
  export default {
    props: {
    },
    data() {
       return {
       }
    },
     
    created() {
    this.$axios
      .post("ares/json/misc/checkToken.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "checkToken"
        },
        checkToken: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
          this.$session.destroy();
          this.$router.push("/");
        }   
      });
    },

    methods: {
      myAccount() {
        console.log("hier");
      }
    }
  }
</script>
